import React from 'react';
import { cn } from '@/utils/utils';

interface ProductCardSkeletonProps {
    className?: string;
    imageSize?: 'sm' | 'md' | 'lg';
}

const ProductCardSkeleton: React.FC<ProductCardSkeletonProps> = ({
    className,
    imageSize = 'md',
}) => {
    const imageSizes = {
        sm: 'h-48',
        md: 'h-64',
        lg: 'h-80',
    };

    return (
        <div
            className={cn(
                'bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden animate-pulse',
                className
            )}
        >
            {/* Imagen skeleton */}
            <div className={cn('bg-gray-200', imageSizes[imageSize])} />

            {/* Contenido skeleton */}
            <div className="p-4">
                {/* Categoría skeleton */}
                <div className="h-3 bg-gray-200 rounded w-16 mb-2" />

                {/* Título skeleton */}
                <div className="space-y-2 mb-3">
                    <div className="h-4 bg-gray-200 rounded w-full" />
                    <div className="h-4 bg-gray-200 rounded w-3/4" />
                </div>

                {/* Rating skeleton */}
                <div className="flex items-center gap-1 mb-2">
                    <div className="flex space-x-1">
                        {[...Array(5)].map((_, i) => (
                            <div key={i} className="w-3 h-3 bg-gray-200 rounded" />
                        ))}
                    </div>
                    <div className="h-3 bg-gray-200 rounded w-8 ml-2" />
                </div>

                {/* Precio skeleton */}
                <div className="flex items-center gap-2 mb-2">
                    <div className="h-6 bg-gray-200 rounded w-20" />
                    <div className="h-4 bg-gray-200 rounded w-16" />
                </div>

                {/* Stock skeleton */}
                <div className="flex items-center justify-between">
                    <div className="h-3 bg-gray-200 rounded w-24" />
                    <div className="h-3 bg-gray-200 rounded w-20" />
                </div>

                {/* Botón skeleton (móvil) */}
                <div className="mt-3 md:hidden">
                    <div className="h-9 bg-gray-200 rounded w-full" />
                </div>
            </div>
        </div>
    );
};

export default ProductCardSkeleton;